export default {
  network: {
      normal: "未知错误",
      unavailable: "当前网络不可用,请检查你的网络",
      failedReceiveMessage: "收取消息失败",
      disconnect: "连接断开",
      failedReceiveHistoryMessage: "获取历史消息失败",
      // succeededReceiveHistoryMessage: "获取历史消息成功",
      failedLike: "点赞失败",
      succeededLike: "点赞成功",
  },
  chatInput: {
      inputPrompt: "请输入文字",
  },
  tip: {
      aiTip: "内容由AI生成，不能保证完全可信",
      loading: "页面加载中...",
  },
  mesage: {
      like: "点赞",
      teach: "调教",
      makeMeBetter: "让我变得更好吧",
      teachMe: "教教我",
      betterAnswer: "辛苦大大留下更好、更正确的答案吧",
      throwLink: "甩个链接",
      correctAnswer: "求个正确答案的来源吧，我会努力学东西的",
      pickTeachReson:"至少选一个调教理由哦",
      feedSucessed:"反馈成功",
      submit: "提交"
  },
  time: {
      year: "年",
      month: "月",
      day: "日",
      monday: "星期一",
      tuesday: "星期二",
      wednesday: "星期三",
      thursday: "星期四",
      friday: "星期五",
      saturday: "星期六",
      sunday: "星期日",
      yesterday: "昨天"
  },
  topic: {
      recommendedReply: "推荐答复：",
      nextTopic: "下一个话题：",
      refresh: "刷新", // 刷新话题按钮
      promptHeading: "点击刷新后会出现新的话题推荐哦", // 刷新话题提示语
      noMoreReminders: "不再提醒", // 刷新话题弹窗 [不再提醒]按钮
      cancle: "取消", // 刷新话题弹窗 [取消]按钮
      confirm: "确定", // 刷新话题弹窗 [确定]按钮
      noMoreTopics: "目前没有更多话题啦，努力产出中(๑･`◡´･๑)，敬请期待哦"
  },
};